import { createSlice } from "@reduxjs/toolkit";

const createConfigToken = (token) => {
  // generate configToken
  if (token) {
    const configToken = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return configToken;
  } else {
    return;
  }
};

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: JSON.parse(localStorage.getItem("user"))?.user || null,
    token: JSON.parse(localStorage.getItem("user"))?.token || null,
    configToken:
      createConfigToken(JSON.parse(localStorage.getItem("user"))?.token) ||
      null,
    // When an Admin is using "Log in as client", this holds the original
    // admin {_id, name, email} so the banner can render and the Exit button
    // knows who to come back as. null in normal sessions.
    impersonator:
      JSON.parse(localStorage.getItem("user"))?.impersonator || null,
  },
  reducers: {
    setCredentials: (state, action) => {
      const { user, token, impersonator = null } = action.payload;
      state.user = user;
      state.token = token;
      state.configToken = createConfigToken(token);
      state.impersonator = impersonator;
    },
    logOut: (state, action) => {
      state.user = null;
      state.token = null;
      state.configToken = null;
      state.impersonator = null;
    },
    // Reconcile the stored login snapshot with what /me says this person's
    // role and capabilities are NOW (see state/identitySync.js for why). Merges
    // a narrow patch rather than replacing the user, so the fields /me does not
    // carry — _id, personalClientId, managedClients — survive. Persisted too,
    // or the next reload would re-hydrate the stale snapshot and undo it.
    syncIdentity: (state, action) => {
      if (!state.user || !action.payload) return;
      state.user = { ...state.user, ...action.payload };
      try {
        const stored = JSON.parse(localStorage.getItem("user")) || {};
        if (stored.user) {
          stored.user = { ...stored.user, ...action.payload };
          localStorage.setItem("user", JSON.stringify(stored));
        }
      } catch {
        // A blocked or corrupt localStorage must not break the session; redux
        // already has the fresh values for this page view.
      }
    },
    // Keep the in-memory user's push preference honest after the Settings
    // toggle flips it, so a page reload (which re-hydrates from localStorage)
    // doesn't auto-restore a subscription the user just turned off. Callers
    // persist the same value into localStorage; this only touches redux.
    setPushEnabled: (state, action) => {
      if (state.user) {
        state.user.pushEnabled = action.payload;
      }
    },
  },
});

export const { setCredentials, logOut, setPushEnabled, syncIdentity } =
  authSlice.actions;

export default authSlice.reducer;
